/**
 * Flight and Hotel Bundle Actions
 * Manages flight and hotel bundle data
 */

export const FLIGHT_AND_HOTEL_BUNDLE_UPDATE_FLIGHT_DATA = 'FLIGHT_AND_HOTEL_BUNDLE_UPDATE_FLIGHT_DATA'
export const FLIGHT_AND_HOTEL_BUNDLE_UPDATE_SELECTED_DATES = 'FLIGHT_AND_HOTEL_BUNDLE_UPDATE_SELECTED_DATES'
export const FLIGHT_AND_HOTEL_BUNDLE_RESET = 'FLIGHT_AND_HOTEL_BUNDLE_RESET'

// Action Creators
export interface UpdateFlightDataAction {
  type: typeof FLIGHT_AND_HOTEL_BUNDLE_UPDATE_FLIGHT_DATA
  payload: {
    fetching: boolean
    pricePerPerson?: number
    totalPrice?: number
    journey?: App.JourneyV2
  }
}

export interface UpdateSelectedDatesAction {
  type: typeof FLIGHT_AND_HOTEL_BUNDLE_UPDATE_SELECTED_DATES
  payload: {
    checkIn: string
    checkOut: string
  }
}

export interface ResetBundleAction {
  type: typeof FLIGHT_AND_HOTEL_BUNDLE_RESET
}

export type FlightAndHotelBundleAction =
  | UpdateFlightDataAction
  | UpdateSelectedDatesAction
  | ResetBundleAction

// Action Creators
export function updateFlightData(payload: UpdateFlightDataAction['payload']): UpdateFlightDataAction {
  return {
    type: FLIGHT_AND_HOTEL_BUNDLE_UPDATE_FLIGHT_DATA,
    payload,
  }
}

export function updateSelectedDates(payload: UpdateSelectedDatesAction['payload']): UpdateSelectedDatesAction {
  return {
    type: FLIGHT_AND_HOTEL_BUNDLE_UPDATE_SELECTED_DATES,
    payload,
  }
}

export function resetBundle(): ResetBundleAction {
  return {
    type: FLIGHT_AND_HOTEL_BUNDLE_RESET,
  }
}
